import React from "react";
import { Switch } from "@design-system/Switch/Switch";
import { Tooltip } from "@design-system/Tooltip/Tooltip";

interface Props {
    isActive: boolean;
    onChanged: (isActive: boolean) => void;
}

export const AllFieldsToggle: React.FC<Props> = ({ isActive, onChanged }) => (
    <Tooltip content="Show all fields, including contact and address details">
        <Switch
            checked={isActive}
            onCheckedChange={onChanged}
            label="Show all fields"
            labelHidden
        />
    </Tooltip>
);
